module.exports = __webpack_public_path__ + "img/jose.01f4ab0c.png";